module.exports = __webpack_public_path__ + "static/media/truck.bd2b01e5.svg";